import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { companyPage } from '../../data/mock';
import { Building2 } from 'lucide-react';
import AnimateOnScroll from '../../components/AnimateOnScroll';
import Footer from '../../components/layout/Footer';

const Company = () => {
  const { language } = useLanguage();
  const content = companyPage[language];

  return (
    <div className="min-h-screen relative">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1920&q=80')`,
        }}
      >
        <div className="absolute inset-0 bg-[#1a2a3a]/85" />
      </div>

      <div className="relative z-10 min-h-screen flex flex-col items-center px-4 sm:px-6 pt-24 sm:pt-32 pb-20 sm:pb-24">
        <AnimateOnScroll animation="fadeIn">
          <div className="mb-6 sm:mb-8">
            <Building2 className="text-[#3eb8b3]" size={48} strokeWidth={1} />
          </div>
        </AnimateOnScroll>

        <AnimateOnScroll animation="fadeInUp" delay={100}>
          <h1 className="text-white text-3xl sm:text-4xl md:text-5xl font-light mb-6 sm:mb-8 text-center">
            {content.title}
          </h1>
        </AnimateOnScroll>

        <AnimateOnScroll animation="fadeInUp" delay={200}>
          <p className="text-white/80 text-base sm:text-xl text-center max-w-3xl mb-8 sm:mb-12 leading-relaxed">
            {content.intro}
          </p>
        </AnimateOnScroll>

        <div className="max-w-3xl w-full space-y-6 sm:space-y-8 mb-12 sm:mb-16">
          {content.paragraphs.map((paragraph, index) => (
            <AnimateOnScroll key={index} animation="fadeInUp" delay={300 + index * 100}>
              <p className="text-white/70 text-base sm:text-lg leading-relaxed">
                {paragraph}
              </p>
            </AnimateOnScroll>
          ))}
        </div>

        <Link
          to="/contacto"
          className="bg-[#3eb8b3] text-white px-6 sm:px-8 py-3 sm:py-4 text-base sm:text-lg tracking-wider hover:bg-[#2ea09b] transition-colors hover-glow"
        >
          {content.cta}
        </Link>
      </div>

      <Footer />
    </div>
  );
};

export default Company;
